import { MprcRequestErrorDialog, MprcSpinnerIndicator } from "components";
import { TopicPanelDto, UserPanelDtoPaginatedList } from "generated/CoreApi_v1";
import { useCoreApi } from "providers/CoreApiProvider";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { FeedBoxPanels, FeedDrawerPanels } from "views/knowledge/feed/components/FeedBoxPanels";
import { PanelChannelUsersMostPublication } from "views/knowledge/feed/components/Panel/PanelChannelUsersMostPublication";
import { PanelTopics } from "views/knowledge/feed/components/Panel/PanelTopics";

interface IProps {
    channelId: string;
    renderMode: "default" | "drawer";
    onEmptyPanel: () => void;
}

/**
 * Painel lateral para o feed de Canal.
 * @param props
 */
export const FeedChannelRightPanel: React.FC<IProps> = (props) => {

    const { channelId, renderMode, onEmptyPanel } = props;

    const api = useCoreApi();
    const { t } = useTranslation("knowledge");

    const [viewError, setViewError] = useState<any>();
    const [topicsMention, setTopicsMention] = useState<TopicPanelDto[]>([]);
    const [usersMostPublication, setUsersMostPublication] = useState<UserPanelDtoPaginatedList>();
    const [loading, setLoading] = useState<boolean>(true);

    ////////////////////////////////////////////////////////////////////////////
    /// Effects
    ////////////////////////////////////////////////////////////////////////////

    // Ao carregar
    useEffect(() => {
        if (loading) {
            Promise.all([
                api.v1.knowledgeFeed.getFeedChannelPanelUsersMostPublication({ channelId, pageNumber: 1, pageSize: 5, searchText: null }),
                api.v1.knowledgeFeed.getFeedChannelPanelTopicsMention({ channelId })
            ])
                .then((results) => {
                    setUsersMostPublication(results[0].data);
                    setTopicsMention(results[1].data);
                    if (results[0].data.items.length == 0
                        && results[1].data.length == 0) {
                        onEmptyPanel();
                    }
                })
                .catch((error: any) => {
                    setViewError(error);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [loading]);

    ////////////////////////////////////////////////////////////////////////////
    /// Render
    ////////////////////////////////////////////////////////////////////////////

    const panels = useMemo(() => {
        const data = [];
        if (usersMostPublication)
            data.push(<PanelChannelUsersMostPublication
                title={t("Feed.Panels.ChannelUsersMostPublication.Title")}
                channelId={channelId}
                viewData={usersMostPublication!}
            />
            );

        if (topicsMention.length > 0) {
            data.push(
                <PanelTopics
                    title={t("Feed.Panels.ChannelTopicsMostMention.Title")}
                    viewData={topicsMention}
                />
            );
        }
        return data;
    }, [usersMostPublication, topicsMention]);

    return (
        <>
            <MprcRequestErrorDialog
                error={viewError}
                onClose={() => setViewError(undefined)}
            />

            {
                loading
                    ? <MprcSpinnerIndicator />
                    : renderMode == "default"
                        ? <FeedBoxPanels>{panels}</FeedBoxPanels>
                        : <FeedDrawerPanels>{panels}</FeedDrawerPanels>
            }
        </>
    );
};
